import { GenderEnum, MarriageStatusEnum } from '@pxtra-client-lib-legacy/gen';
import { TFunction } from 'i18next';

class TranslationMap {
  private _t: TFunction;
  private _map: Map<string, string> | null = null;
  private _buildMap: (t: TFunction) => Map<string, string>;

  public constructor(t: TFunction, mapBuilder: (t: TFunction) => Map<string, string>) {
    this._t = t;
    this._buildMap = mapBuilder;
  }

  public get map() {
    this._map = this._map ?? this._buildMap(this._t);
    return this._map as Map<string, string>;
  }

  public get options() {
    return Array.from(this.map, ([key, value]) => ({ value: key, text: value }));
  }

  public render(key: string) {
    return this.map.get(key);
  }
}

class TranslationHelper {
  private _gender: TranslationMap;
  private _marriageStatus: TranslationMap;

  public constructor(t: TFunction) {
    this._gender = new TranslationMap(t, this.buildGenderMap);
    this._marriageStatus = new TranslationMap(t, this.buildMarriageStatusMap);
  }

  public get gender() {
    return this._gender;
  }

  public get marriageStatus() {
    return this._marriageStatus;
  }

  private buildGenderMap(t: TFunction) {
    return new Map<GenderEnum, string>([
      ['male', t('common:MALE')],
      ['female', t('common:FEMALE')],
      ['diverse', t('common:DIVERSE')],
      ['undefined', t('common:UNDEFINED')]
    ]);
  }

  private buildMarriageStatusMap(t: TFunction) {
    return new Map<MarriageStatusEnum, string>([
      ['ledig', t('common:NO')],
      ['verheiratet', t('common:YES')]
    ]);
  }
}

export default TranslationHelper;
